import React, { useEffect } from 'react';
import {LandingPagePropTypes, NeuroMessage} from '@ignitesales/neuro-application/src/neuro-guide';
import queryString from 'query-string';
import AppLoading from '../../AppLoading';
import { loadUrlParameters } from '../../utils/saveParameters.mjs';

const LandingPage = ({ componentClass, onStartGuideClick, isLoadingNextPage }) => {
  const urlQuery = window.location.search;
  const parsed = queryString.parse(urlQuery);
  const skipLandingPage = parsed.quickStart !== undefined;

  useEffect(() => {
    loadUrlParameters();
    (skipLandingPage && !isLoadingNextPage) && onStartGuideClick()
  }, [])
  
  return  skipLandingPage ? <AppLoading /> : (
    <div className={componentClass}>
      <div className={`${componentClass}__container`}>

        <div className={`${componentClass}__container--sixty`}>
          <div className="background">
            <img src="/classpath/assets/images/background-landing.jpg" />
          </div>
        </div>

        <div className={`${componentClass}__container--forty`}>
          <div className={`${componentClass}__message`}>
            <NeuroMessage id="landing.message" tagName="h2"/>
            <button onClick={() => onStartGuideClick()} disabled={isLoadingNextPage} className="btn btn-primary">
              <NeuroMessage id="landing.getStarted" />
            </button>
          </div>
        </div>

      </div>
      <div className="decoration decoration__landing">
        <div className="blue-circle"></div>
        <div className="yellow-circle"></div>
      </div>
    </div>
  );
};

LandingPage.propTypes = LandingPagePropTypes;

export default LandingPage;
